import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { getClientListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getPropertiesListing = (payload: getClientListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getPropertiesListing`,
        payload
      );
      dispatch({
        type: action_types.GET_PROPERTY_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_PROPERTY_LISTING,
        data: { loading: false },
      });
    }
  };
};

export const removePropertiesListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_PROPERTY_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getPropertyDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getPropertyDetails/${id}`);
      dispatch({
        type: action_types.GET_PROPERTY_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_PROPERTY_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removePropertyDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_PROPERTY_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};

export const getPropertyFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getPropertyFormData/${id}`);
    dispatch({
      type: action_types.PROPERTY_FORM_DATA,
      data,
    });
  };
};

export const getClientContacts = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const { data } = await axios.get(`${baseURL}getClientContacts/${id}`);
    dispatch({
      type: action_types.GET_CLIENT_CONTACT,
      data,
    });
  };
};
